import axios from "../axios/axios";
import { setNotifications } from "../store/actions/notificationAction";
import { errorDispatcher } from "../helpers";

export const apiGetNotifications = (token, isRead) => (dispatch) => {
  axios
    .get(`notifications/list?isRead=${isRead ? 1 : 0}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setNotifications(response.data.notifications));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiReadNotifications = (token, callback, id, readAll) => (dispatch) => {
  let params = {}
  if (readAll) {
    params["readAll"] = true
  } else {
    params['id'] = id
  }
  axios
    .get("notifications/read", {
      headers: { Authorization: `Bearer ${token}` },
      params,
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiGetItemNotifications = (token, detail_id, detail_type, callback) => (dispatch) => {
  axios
    .get("notifications", {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        detail_id,
        detail_type,
      },
    })
    .then((response) => {
      callback(response?.data?.notifications);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiCreateNotifications =
  (token, detail_id, detail_type, title, message, fireDate, callback) => (dispatch) => {
    axios
      .post(
        "notifications",
        {
          detail_id,
          detail_type,
          title,
          message,
          fireDate,
        },

        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        callback(response);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch, false);
      });
  };
export const apiEditNotifications = (token, notificationId, active, callback) => (dispatch) => {
  axios
    .put(
      `notifications/${notificationId}`,
      {
        active,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiDeleteNotifications = (token, notificationId, callback) => (dispatch) => {
  axios
    .delete(`notifications/${notificationId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiGetSystemNotifications = ( callback) => (dispatch,getState) => {
  const token = getState().businessReducer.business?.token;

  axios
    .get("notifications/coreNotifications/list", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback(response?.data?.notifications);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
}
